
import { useState } from 'react';

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  const testimonials = [
    {
      name: 'Marie-Claire Dubois',
      location: 'Pointe-à-Pitre',
      rating: 5,
      text: 'Une expérience absolument magique ! Le massage aux pierres chaudes m\'a procuré une détente que je n\'avais jamais ressentie. L\'équipe est professionnelle et l\'ambiance tropicale parfaite.',
      service: 'Massage aux Pierres Chaudes',
      avatar: 'https://public.readdy.ai/ai/img_res/063cf920389f5c3a5b37d1f83444e6f3.jpg'
    },
    {
      name: 'Jean-Luc Martin',
      location: 'Basse-Terre',
      rating: 5,
      text: 'Après des années de douleurs dorsales, le massage deep tissue a vraiment fait la différence. Je recommande vivement Zen Wellness pour leur expertise et leur approche personnalisée.',
      service: 'Massage Deep Tissue',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20satisfied%20middle-aged%20Caribbean%20man%2C%20genuine%20smile%2C%20relaxed%20appearance%2C%20spa%20client%2C%20wellness%20customer%2C%20tropical%20setting%2C%20natural%20lighting&width=100&height=100&seq=client-jean&orientation=squarish'
    },
    {
      name: 'Sophie Leroy',
      location: 'Le Gosier',
      rating: 5,
      text: 'Le service à domicile est fantastique ! Pouvoir profiter d\'un massage professionnel chez soi, c\'est le luxe ultime. L\'aromathérapie avec les huiles locales est un pur bonheur.',
      service: 'Massage à Domicile',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20young%20Caribbean%20woman%2C%20bright%20smile%2C%20wellness%20client%2C%20spa%20customer%2C%20tropical%20environment%2C%20natural%20lighting%2C%20peaceful%20expression&width=100&height=100&seq=client-sophie&orientation=squarish'
    },
    {
      name: 'Pierre Moreau',
      location: 'Saint-François',
      rating: 5,
      text: 'La réflexologie plantaire a dépassé mes attentes. Non seulement mes pieds se sentent mieux, mais j\'ai remarqué une amélioration générale de mon bien-être. Service exceptionnel !',
      service: 'Réflexologie Plantaire',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20content%20elderly%20Caribbean%20man%2C%20warm%20smile%2C%20satisfied%20spa%20client%2C%20wellness%20customer%2C%20tropical%20background%2C%20natural%20lighting%2C%20peaceful%20demeanor&width=100&height=100&seq=client-pierre&orientation=squarish'
    },
    {
      name: 'Isabelle Durand',
      location: 'Sainte-Anne',
      rating: 5,
      text: 'Mon mari et moi avons pris le forfait couple. Quelle merveilleuse expérience de partager ce moment de détente ensemble ! L\'ambiance est parfaite et les thérapeutes excellents.',
      service: 'Forfait Couple',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20elegant%20middle-aged%20Caribbean%20woman%2C%20serene%20smile%2C%20spa%20client%2C%20wellness%20customer%2C%20tropical%20setting%2C%20natural%20lighting%2C%20relaxed%20appearance&width=100&height=100&seq=client-isabelle&orientation=squarish'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ce que Disent nos <strong>Clients</strong> en <strong>Guadeloupe</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez les témoignages authentiques de nos clients satisfaits qui ont vécu 
            une expérience de <strong>bien-être</strong> exceptionnelle avec nos services.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-center mb-6">
              <img 
                src={testimonials[currentTestimonial].avatar}
                alt={`Photo de ${testimonials[currentTestimonial].name}`}
                className="w-16 h-16 rounded-full object-cover mr-4"
              />
              <div>
                <h3 className="text-xl font-bold text-gray-900">
                  {testimonials[currentTestimonial].name}
                </h3>
                <p className="text-gray-600">{testimonials[currentTestimonial].location}</p>
                <div className="flex items-center mt-1">
                  {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                  ))}
                  <span className="ml-2 text-sm text-gray-500">
                    {testimonials[currentTestimonial].service}
                  </span>
                </div>
              </div>
            </div>
            
            <blockquote className="text-lg md:text-xl text-gray-700 leading-relaxed italic mb-6">
              "{testimonials[currentTestimonial].text}"
            </blockquote>
            
            <div className="flex items-center justify-between">
              <button 
                onClick={prevTestimonial}
                className="w-12 h-12 bg-teal-600 hover:bg-teal-700 text-white rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              
              <div className="flex space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentTestimonial(index)}
                    className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                      index === currentTestimonial ? 'bg-teal-600' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
              
              <button 
                onClick={nextTestimonial}
                className="w-12 h-12 bg-teal-600 hover:bg-teal-700 text-white rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-heart-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">500+</h3>
            <p className="text-gray-600">Clients Satisfaits</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-star-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">4.9/5</h3>
            <p className="text-gray-600">Note Moyenne</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">5 ans</h3>
            <p className="text-gray-600">D'Excellence</p>
          </div>
        </div>
      </div>
    </section>
  );
}
